/********************************************************************************
 * Copyright (c) 2020 Cedalo GmbH
 *
 * This program and the accompanying materials are made available under the
 * terms of the Eclipse Public License 2.0 which is available at
 * http://www.eclipse.org/legal/epl-2.0.
 *
 * SPDX-License-Identifier: EPL-2.0
 *
 ********************************************************************************/
import Typography from '@mui/material/Typography';
/* eslint-disable react/prop-types */
import React from 'react';

/**
 * A modal dialog can only be closed by selecting one of the actions.
 */
export class SystemInfo extends React.Component {


	render() {
		const version = process.env.REACT_APP_VERSION || '3.0';
		const build = process.env.REACT_APP_BUILD_NUMBER || '0.0.0.0';
		return (
			<div style={{marginTop: '20px'}}>
				<Typography style={{margin: '5px'}}>
					<span style={{fontWeight: 'bold'}}>Version: </span>{version}
				</Typography>
				<Typography style={{margin: '5px'}}>
					<span style={{fontWeight: 'bold'}}>Build: </span>{build}
				</Typography>
			</div>
        );
	}
}

